export enum ISOInstallMethod {
    MERGE, REPLACE
}
